import React from "react";
import { ScrollText, User } from "lucide-react";
import { traditionColor, NEUTRAL_TRADITION } from "@/lib/traditionColors";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { CARD_W, CARD_H, ROW_GAP } from "./timelineLayout";

export const TimelineCard = ({ item, above, onSelect, activeId, dimmed }) => {
  const ks = item.knowledge_systems?.[0];
  const color = ks ? traditionColor(ks.id) : NEUTRAL_TRADITION;
  const active = activeId === item.id;
  const card = (
    <button
      data-testid={`timeline-item-${item.id}`}
      onClick={() => onSelect(item.id)}
      style={{
        left: item.x,
        [above ? "bottom" : "top"]: item.row * (CARD_H + ROW_GAP),
        width: CARD_W,
        borderLeftColor: color,
        opacity: dimmed ? 0.22 : 1,
      }}
      className={`absolute text-left bg-white rounded-lg border border-[#14140f]/10 border-l-[3px] px-2.5 py-1.5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all ${
        active ? "ring-2 ring-[#ff7360]" : ""
      }`}
    >
      <div className="flex items-center gap-1.5">
        {item.type === "text" ? (
          <ScrollText className="w-3 h-3 shrink-0" style={{ color }} />
        ) : (
          <User className="w-3 h-3 shrink-0" style={{ color }} />
        )}
        <span className="font-serif text-[13px] leading-tight text-[#14140f] truncate">
          {item.label}
        </span>
      </div>
      <div className="flex items-center gap-1.5 mt-1">
        <span className="text-[10px] text-[#4e6073] shrink-0">{item.year_display}</span>
        {ks && (
          <span
            className="inline-flex items-center gap-1 text-[9px] font-medium rounded-full px-1.5 py-0.5 truncate"
            style={{ background: `${color}22`, color: "#14140f" }}
            data-testid={`timeline-item-ks-${item.id}`}
          >
            <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: color }} />
            {ks.label}
          </span>
        )}
      </div>
    </button>
  );
  if (!item.summary) return card;
  return (
    <HoverCard openDelay={150} closeDelay={80}>
      <HoverCardTrigger asChild>{card}</HoverCardTrigger>
      <HoverCardContent
        side={above ? "top" : "bottom"}
        align="start"
        className="w-64 p-3 bg-[#14140f] text-[#fdfdfb] border-[#14140f] shadow-xl"
        data-testid={`timeline-hover-${item.id}`}
      >
        <div className="flex items-center gap-1.5 mb-1">
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background: color }} />
          <span className="font-serif text-sm leading-tight">{item.label}</span>
        </div>
        <div className="text-[11px] text-[#fdfdfb]/60 mb-1.5">
          {item.type === "text" ? "Text" : "Thinker"}
          {ks ? ` · ${ks.label}` : ""} · {item.year_display}
        </div>
        <p className="text-xs leading-snug text-[#fdfdfb]/90">{item.summary}</p>
      </HoverCardContent>
    </HoverCard>
  );
};
